import React, { FC, useState } from 'react'
import dayjs from 'dayjs'
import { MdOutlineArrowForwardIos } from 'react-icons/md'
import { Rating } from './Rating'
import { BaseImage } from '../../Image'
import PhotoSwiper from '../../PhotoSwiper'
import { FITTING_ARR } from './config'

// eslint-disable-next-line import/prefer-default-export
export const ReviewList: FC<{
  figure: any
  reviewList: any[]
  previewLimit?: number
  disableViewMore?: boolean
  className?: string
  isExtension?: boolean
}> = ({
  figure,
  reviewList,
  previewLimit = 6,
  disableViewMore,
  className,
  isExtension = false,
}) => {
  const [previewOpen, setPreviewOpen] = useState<boolean>(false)
  const [urlList, setUrlList] = useState([])
  const [photoIndex, setPhotoIndex] = useState(0)
  const onClose = () => {
    setTimeout(() => setPreviewOpen((val) => !val), 300)
    if (isExtension) return
    window.parent.postMessage(
      {
        reviews: 'CloseFullScreen',
      },
      '*'
    )
  }
  const previewHandle = (arr: any, index: number) => {
    console.log(arr)
    setUrlList(arr.map((i: any) => i.url))
    setPhotoIndex(index)
    setPreviewOpen(true)
  }

  const getFigureObject = (fig: string) => JSON.parse(fig)

  const getFigureKeys = (fig: string): string[] =>
    Object.keys(getFigureObject(fig))

  const chartAtFirstWord = (name: string): string =>
    name.charAt(0).toUpperCase() + name.slice(1, -1)

  return (
    <div className={`${className} flex flex-wrap`}>
      {reviewList.map((i, ikey) => (
        <div
          key={i.id + ikey}
          className="flex flex-wrap py-4 w-full border-b-1 border-tag-grayef"
        >
          <div className="flex w-full items-center">
            <div className="flex-shrink-0 flex justify-center items-center w-8 h-8 border rounded-full border-tag-grayef">
              {(i.reviewerName || '?').slice(0, 1).toUpperCase()}
            </div>
            <div className="flex flex-wrap pl-2 min-w-0 w-full h-8">
              {/* 暂时无法实现SKU绑定，所以暂缓新设计稿
              <div className="flex flex-nowrap items-center w-full min-w-0 text-black text-xs font-semibold">
                <span className="inline-block min-w-0 overflow-hidden whitespace-nowrap overflow-ellipsis">
                  {i?.reviewerName || 'Anonymous'}
                </span>
                <Rating
                  type="outline"
                  value={i.rating.toFixed(1)}
                  length={5}
                  openHalf={false}
                  className="pl-2 flex-grow flex flex-nowrap items-center star-xxs"
                />
                <span
                  className="text-gray-400 font-medium"
                  style={{
                    transform: 'scale(0.8333)',
                    transformOrigin: 'left center',
                  }}
                >
                  {dayjs
                    .tz(i?.createdAt || 0, dayjs.tz.guess())
                    .format('MM/DD/YYYY')}
                </span>
              </div>
              <div
                className="w-full min-w-0 mt-0.5 text-gray-400 text-xs font-medium"
                style={{
                  transform: 'scale(0.8333)',
                  transformOrigin: 'left bottom',
                }}
              >
                Color: Black
                <span className="px-1.5" />
                US Size: 12/L
              </div>
              暂时无法实现SKU绑定，所以暂缓新设计稿 */}
              <div className="flex flex-nowrap w-full min-w-0 text-gray-400 text-xs font-medium">
                <span className="inline-block min-w-0 overflow-hidden whitespace-nowrap overflow-ellipsis">
                  {i?.reviewerName || 'Anonymous'}
                </span>
                <span className="inline-block px-1.5 transform scale-150">
                  ·
                </span>
                <span>
                  {dayjs
                    .tz(i?.createdAt || 0, dayjs.tz.guess())
                    .format('MM/DD/YYYY')}
                </span>
              </div>
              <Rating
                type="outline"
                value={i.rating.toFixed(1)}
                length={5}
                openHalf={false}
                className="w-full star-xxs"
              />
            </div>
          </div>
          <div className="w-full">
            {!!i?.title && (
              <div className="mt-3 -mb-2 text-black font-semibold text-14">
                {unescape(i?.title)}
              </div>
            )}
            <div className="mt-3 text-xs text-black font-medium">
              {unescape(i?.body)}
            </div>
            {i?.medias.length ? (
              <div className="mt-3 w-full grid grid-cols-3 gap-x-1 gap-y-1">
                {i?.medias
                  .filter((m: { type: number }) => m.type === 0)
                  .slice(0, previewLimit)
                  .map((m: any, mkey: number) => (
                    <div
                      className="flex w-full items-start justify-center overflow-hidden relative"
                      style={{ paddingTop: `${(100 / 100) * 100}%` }}
                      key={i.id + mkey}
                    >
                      <div className="absolute top-0 left-0 w-full h-full cursor-pointer">
                        <BaseImage
                          layout="fill"
                          objectFit="cover"
                          src={m.url}
                          onClick={() => {
                            setTimeout(
                              () =>
                                previewHandle(
                                  i?.medias.filter(
                                    (item: { type: number }) => item.type === 0
                                  ),
                                  mkey
                                ),
                              50
                            )
                            if (isExtension) return
                            window.parent.postMessage(
                              {
                                reviews: 'OpenFullScreen',
                              },
                              '*'
                            )
                          }}
                        />
                      </div>
                      {!disableViewMore &&
                      i?.medias.length > previewLimit &&
                      mkey === previewLimit - 1 ? (
                        <div
                          className="absolute top-0 left-0 flex justify-center items-center w-full h-full text-white font-medium pointer-events-none"
                          style={{ background: 'rgba(0,0,0,0.6)' }}
                        >
                          {i?.medias.length - (previewLimit - 1)} Left
                          <MdOutlineArrowForwardIos
                            color="inherit"
                            fontSize="15"
                            className="ml-0.5"
                          />
                        </div>
                      ) : null}
                    </div>
                  ))}
              </div>
            ) : null}

            {i?.figure && (
              <div
                className="flex w-full min-w-0 mt-0.5 text-gray-400 text-xs font-medium -mb-1"
                style={{
                  transform: 'scale(0.8333)',
                  transformOrigin: 'left bottom',
                }}
              >
                <div className="flex flex-wrap w-full">
                  <div className="mb-1 flex w-1/2">
                    Overall Fit:{' '}
                    {(i?.extendForm &&
                      FITTING_ARR.find(
                        (item) =>
                          item.value === JSON.parse(i.extendForm).fitting
                      )?.label) ||
                      'Unset'}
                  </div>
                  {getFigureKeys(i.figure).map(
                    (item) =>
                      figure?.[item][getFigureObject(i.figure)[item]] && (
                        <div className="mb-1 flex w-1/2">
                          {chartAtFirstWord(item)}
                          {item === 'hips' && 's'}:{' '}
                          {figure?.[item][getFigureObject(i.figure)[item]]}
                        </div>
                      )
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}

      {previewOpen && (
        <PhotoSwiper
          images={urlList}
          open={previewOpen}
          onOpenChange={onClose}
          initialSlide={photoIndex}
        />
      )}
    </div>
  )
}
